import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import Loader from "../../components/ui/Loader";
import Text from "../../components/ui/Text";

import buildZippyDeepLink from "./buildZippyDeepLink";
import type { MagicLinkFlow } from "./types";

function isMagicLinkFlow(flow: string | undefined): flow is MagicLinkFlow {
  return flow === "bind" || flow === "login";
}

const MSG_INVALID_LINK = "This link is invalid or has expired.";
const MSG_MISSING_TOKEN =
  "This link is missing a valid token. Please request a new email.";

export default function MagicLinkHandler() {
  const { flow: flowParam } = useParams();
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const token = searchParams.get("token")?.trim() ?? "";

  useEffect(() => {
    setErrorMessage(null);

    if (!isMagicLinkFlow(flowParam)) {
      setErrorMessage(MSG_INVALID_LINK);
      return;
    }

    if (!token) {
      setErrorMessage(MSG_MISSING_TOKEN);
      return;
    }

    window.location.href = buildZippyDeepLink(flowParam, token);
  }, [flowParam, token]);

  if (errorMessage) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-pink1 px-6">
        <Text className="text-center text-[17px] font-medium leading-[22px] text-black6">
          {errorMessage}
        </Text>
      </div>
    );
  }

  return <Loader />;
}
